import React, { useEffect, useState } from "react";
import {
	BrowserRouter,
	Routes,
	Route,
	useLocation,
	Navigate,
} from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../src/Assets/Common.css";
import "../src/Assets/Variables.css";
import LeftSidebar from "./Components/LeftSidebar/LeftSidebar";
import InternetStatusListener from "./Components/InternetStatusListener/InternetStatusListener";
import Header from "./Components/Header/Header";
import Home from "./Pages/Home/Home";
import Therapists from "./Pages/Therapists/MainPage/Therapists";
import Transactions from "./Pages/Transactions/Transactions";
import Reports from "./Pages/Reports/Components/Reports/Reports";
import Clients from "./Pages/Clients/Clients";
import { GlobalProvider } from "./Context/GlobalContext";
import Login from "./Pages/Login/Login";
import Forgotpassword from "./Pages/Login/Forgotpassword";
import Resetpassword from "./Pages/Login/Resetpassword";
import ProtectedRoute from "./Components/ProtectedRoute";
import Bookings from "./Pages/Bookings/Bookings";
import PayrollReportDownloadListener from "./Components/DownloadNotifications/PayrollReportDownloadListener";
import OutletAccessUnauthorizedListener from "./Components/Sockect/OutletAccessUnauthorizedListener";
import {
	clearStaleMembershipPaymentToast,
	MEMBERSHIP_PAYMENT_TOAST_EVENT,
} from "./Utils/membershipPaymentToast";
import { initializeTokenManager } from "./Utils/tokenManager";

function Layout() {
	const [isSidebarOpen, setIsSidebarOpen] = useState(false);

	const toggleSidebar = () => {
		setIsSidebarOpen((prev) => !prev);
	};

	const location = useLocation();
	const hideHeaderRoutes = [
		"/login",
		"/register",
		"/forgotpassword",
		"/resetpassword",
	];

	useEffect(() => {
		initializeTokenManager();
	}, []);

	useEffect(() => {
		const showGlobalToast = (payload) => {
			try {
				const detail = payload && typeof payload === "object" ? payload : {};
				const message = detail?.message != null ? String(detail.message).trim() : "";
				if (!message) return;
				const type = String(detail?.type || "success").toLowerCase();
				const options =
					detail?.options && typeof detail.options === "object" && !Array.isArray(detail.options)
						? detail.options
						: undefined;
				const mergedOptions = { containerId: "app", ...(options || {}) };
				if (type === "error") toast.error(message, mergedOptions);
				else if (type === "info") toast.info(message, mergedOptions);
				else if (type === "warning" || type === "warn") toast.warn(message, mergedOptions);
				else toast.success(message, mergedOptions);
			} catch (_e) {
			}
		};

		clearStaleMembershipPaymentToast();

		const handler = (event) => showGlobalToast(event?.detail);
		window.addEventListener(MEMBERSHIP_PAYMENT_TOAST_EVENT, handler);
		return () => window.removeEventListener(MEMBERSHIP_PAYMENT_TOAST_EVENT, handler);
	}, []);

	return (
		<GlobalProvider>
			<div className="app">
				<ToastContainer containerId="app" position="top-right" autoClose={3000} />
				<InternetStatusListener />
				<PayrollReportDownloadListener />
				<OutletAccessUnauthorizedListener />
				{!hideHeaderRoutes.includes(location.pathname) && (
					<Header toggleSidebar={toggleSidebar} />
				)}
				{/* <Header toggleSidebar={toggleSidebar} /> */}
				<LeftSidebar isOpen={isSidebarOpen} />
				<Routes>
					<Route element={<ProtectedRoute />}>
						<Route
							exact
							path="/"
							element={<Home isSidebarOpen={isSidebarOpen} />}
						/>
						<Route path="/therapists" element={<Therapists />} />
						<Route path="/sales" element={<Bookings />} />
						<Route path="/clients" element={<Clients />} />
						<Route path="/transactions" element={<Transactions />}/>
						<Route path="/reports" element={<Reports />} />
					</Route>
					<Route path="/login" element={<Login />} />
					<Route
						path="/forgotpassword"
						element={<Forgotpassword />}
					/>
					<Route path="/resetpassword" element={<Resetpassword />} />
					{/* ✅ Catch-all route for invalid paths */}
					<Route
						path="*"
						element={<Navigate to="/login" replace />}
					/>
				</Routes>
			</div>
		</GlobalProvider>
	);
}
const App = () => {
	return (
		<BrowserRouter>
			<Layout />
		</BrowserRouter>
	);
};

export default App;
